// sections/SectionDisability.jsx
import React from 'react';
import { Accessibility } from 'lucide-react';
import { Row, Col, Select, SectionTitle, FormField, Checkbox } from '../../../SharedInputs.jsx';
import { DISABILITY_AREAS } from '../../../../constants.js';

export function SectionDisability({ value, onChange, errors = [], dispatch }) {
  const updateField = (field, fieldValue) => {
    onChange({ ...value, [field]: fieldValue });
  };

  const toggleDisabilityArea = (area) => {
    dispatch({
      type: 'TOGGLE_ARRAY_ITEM',
      section: 'disability',
      field: 'areas',
      value: area
    });
  };

  return (
    <div>
      <SectionTitle icon={Accessibility} step={6}>Disability</SectionTitle>
      
      <Row>
        <Col span={6}>
          <FormField label="Do you consider yourself to have a disability, impairment or long-term condition?"
          hint={"If you indicated the presence of a disability, impairment or long-term condition., please select the area(s) in the following list. "}>
            <Select value={value.hasDisability} onChange={(e) => updateField('hasDisability', e.target.value)}>
              <option value="No">No</option>
              <option value="Yes">Yes</option>
            </Select>
          </FormField>
        </Col>
      </Row>

      {value.hasDisability === "Yes" && (
        <Row>
          <Col span={12}>
            <FormField label="Please Review the disability supplement to help you select the right area(s).">
              <div style={{ 
                display: 'grid', 
                gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', 
                gap: 8, 
                marginTop: 8 
              }}>
                {DISABILITY_AREAS.map(area => (
                  <Checkbox
                    key={area}
                    checked={value.areas.includes(area)}
                    onChange={() => toggleDisabilityArea(area)}
                  >
                    {area}
                  </Checkbox>
                ))}
              </div>
            </FormField>
          </Col>
        </Row>
      )}

      <div style={{
        marginTop: 24,
        padding: 16,
        background: '#f0f9ff',
        borderRadius: 8,
        border: '1px solid #bfdbfe'
      }}>
        <p style={{ fontSize: 14, color: '#1e40af', margin: 0 }}>
          CIET is committed to providing equal access and support for all students. 
          If you indicate you have support needs, our Student Support team will contact 
          you to discuss reasonable adjustments and support services available.
        </p>
      </div>
    </div>
  );
}